"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedKeyAccount = void 0;
/**
 * creates a localized keyaccount object and can be converted into a string.
 */
class LocalizedKeyAccount {
    /**
     *
     * @param keyAccount number
     * @param country string two chars country code
     * @param language string two chars language code
     */
    constructor(keyAccount, country, language) {
        this.keyAccount = keyAccount;
        this.language = language;
        this.country = country;
    }
    /**
     * returns a string representation of the localized keyaccount.
     */
    toString() {
        return [this.language, this.country, this.keyAccount.toString()].filter(item => item.length > 0).join('_') || '';
    }
}
exports.LocalizedKeyAccount = LocalizedKeyAccount;
